import React from 'react';
import { Centered, NoticeButton } from './style';

// A draft pinned to Bulk Upload v2 opened on a phone (build doc 06 D14, §7.1):
// Check pages isn't built for phones, so the draft continues on a computer.
export const MOBILE_V2_COPY = Object.freeze({
  title: 'This upload was started on a computer',
  body: 'Sorting pages needs a bigger screen. Open this draft on a computer to continue.',
  back: 'Back to drafts',
});

export default function BulkUploadV2MobileNotice({ onBack }) {
  return (
    <Centered data-testid="bulk-upload-v2-mobile-notice">
      <strong>{MOBILE_V2_COPY.title}</strong>
      <span>{MOBILE_V2_COPY.body}</span>
      {onBack && (
        <NoticeButton type="button" onClick={onBack}>
          {MOBILE_V2_COPY.back}
        </NoticeButton>
      )}
    </Centered>
  );
}
